<template>
  <sidebar
    :title="title"
    :url="url"
    :icon="icon"
    :show-icon="showIcon"
    @actionButtonClick="$emit('actionButtonClick')"
  >
    <the-search
        v-model="searchFraze"
        class="queries-search bool-radius"
        :focus="searchFocus"
        :is-searching="isSearching"
        @search="searchQueries"
        @clearSearch="clearSearch"
    />

    <div class="content">
      <ul>
        <li
          v-for="(item, index) in data"
          :key="`q-s-item-${index}`"
          class="flex items-center justify-start"
          :class="[selectedItemId == item.id ? 'active' : '']"
        >
          <div class="dot" :style="dotColour(item)" />
          <router-link :to="{path: itemUrl(item)}">{{item.name || 'ID: ' + item.id}}</router-link>
        </li>
        <li ref="observerBottomTarget"></li>
      </ul>

      <!-- Infinite Load Icon-->
      <div v-if="isLoading" class="text-center">
        <loader-inline class="gray sm" />
      </div>

    </div>
  </sidebar>
</template>

<script>
// Components
import sidebar from '../../sidebar.vue';
import theSearch from "../../Search";
import loaderInline from '../../../components/loader-inline.vue'

// Mixins
import infiniteLoad from "../../../mixins/boolean-search/infiniteLoad";
import searchesGroupsSearch from "../../../mixins/boolean-search/searchesGroupsSearch";

//Config
import { searchTypes, multiSyntaxSearch } from "../../../config/bool-const";

//Plugins
import find from 'lodash/find';

export default {
  name: "queries-sidebar",
  props: {
    title: {
      type: String,
      default: 'Queries'
    },
    type: {
      type: String,
      required: true
    },
    data: {
      type: Array,
    },
    isLoading: Boolean,
    url: {
      type: String,
      isRequired: true
    },
    icon: {
      type: String,
      default: 'far fa-plus-circle'
    },
    showIcon: Boolean,
    isGroupType: Boolean,
    isTagSearchType: Boolean,
  },

  mixins: [ infiniteLoad, searchesGroupsSearch ],

  created() {
    this.searchId = this.$route.params.search_id
    this.groupId = this.$route.params.group_id
    this.tagSearchId = this.$route.params.tagSearch_id
  },

  mounted() {
    this.initInfiniteLoad(this.type, this.$refs.observerBottomTarget, `${this.type}CanLoadMore`)
  },

  data() {
    return {
      searchId: null,
      groupId: null,
      tagSearchId: null,
    }
  },

  computed: {
    project_id() { return this.$store.state.booleanSearch.project_id },
    selectedItemId() { 
      if(this.isGroupType) return this.groupId 
      if(this.isTagSearchType) return this.tagSearchId
      return this.searchId 
    }
  },

  methods: {
    itemUrl(item) {
      let url =  `/clients/${this.client_id}/projects/${this.project_id}/`
      if(this.type === 'group_library') url += `searches/group_library/${item.id}`
      else if (this.type === 'tag_library') url += `tags/${item.id}`
      else url += `searches/${item.id}`

      return url
    },
    dotColour(item) {
      let color;

      if(this.isGroupType || this.isTagSearchType) {
        color = '#9CA3AF';
      }
      else if(item.is_multi){
        color = multiSyntaxSearch.color;
      }
      else {
        let searchTypeOptions = find(searchTypes, type => type.value === item.search_type);
        color = searchTypeOptions && searchTypeOptions.color && searchTypeOptions.color.trim() !== '' ? searchTypeOptions.color : '#754cf5';
      }

      return `backgroundColor: ${color};`
    },
  },

  components: {
    sidebar,
    theSearch,
    loaderInline
  }
}
</script>